import { Builder } from '@builder.io/react';
import { OfferingList } from './OfferingList';

Builder.registerComponent(OfferingList, {
  name: 'Offering List',
  image: 'https://cdn.olokoo.com/builder/icons/simple-q2m-icon.svg',
  inputs: [
    {
      name: 'quantity',
      type: 'number',
      defaultValue: 10
    }
  ]
});
